import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import ImgContainer from './components/ImgContainer/ImgContainer';
import LayoutCenter from './components/LayoutCenter/LayoutCenter';
import NotFound from './components/NotFound/NotFound';
import { fetchIndustries, fetchTypeSeries } from './api/services';
import './App.less';
import DownloadPage from './components/Download/download';
import { IntlProvider } from 'react-intl';
import { messages } from './locales';
import { lang } from './api/config';
import { FormattedMessage } from 'react-intl';
import Loading from './components/Loading/Loading';
// const getIndustriesWithHandbook = lang => {
//   return lang === 'en'
//     ? [
//         'EnterpriseNetwork',
//         'IndustrialDigitalization',
//         'Mobility',
//         'SmartCommerce',
//       ]
//     : [
//         'EnterpriseNetwork',
//         'IndustrialDigitalization',
//         'SmartCommerce',
//         'Mobility',
//         'DigitalEnergy',
//       ];
// };

export default function App() {
  const INDUSTRIES_WITH_HANDBOOK =[
    'EnterpriseNetwork',
    'IndustrialDigitalization',
    'SmartCommerce',
    'Mobility',
    'DigitalEnergy',
  ]

  const [state, setState] = useState({
    industries: [],
    typeSeries: [],
    selectedIndustry: null,
    openType: null,
    selectedSeries: null,
    loading: true,
    keyword: '',
    flag: false,
  });

  const {
    industries,
    typeSeries,
    selectedIndustry,
    openType,
    selectedSeries,
    loading,
    keyword,
    flag,
  } = state;
  // 添加一个状态来控制是显示 Loading 还是 404
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    // 10秒后将 loading 状态设置为 false
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);
  // 加载行业列表
  useEffect(() => {
    fetchIndustries()
      .then(data => {
        if (data && data.result) {
          const industryMap = {
            EnterpriseNetwork: 0,
            IndustrialDigitalization: 1,
            DigitalEnergy: 2,
            SmartCommerce: 3,
            Mobility: 4,
            CloudServices: 5,
          };
          const res = [];
          data.result.forEach(item => {
            if (industryMap[item.id] !== undefined) {
              res[industryMap[item.id]] = item;
            } else {
              res.push(item);
            }
          });
          setState(prevState => ({ ...prevState, industries: res }));
        }
      })
      .catch(error => {
        console.error('Error fetching industries:', error);
      });
  }, []);

  // 加载类型系列列表
  useEffect(() => {
    if (industries.length === 0 || !selectedIndustry) {
      // 如果没有行业数据或没有选中的行业，直接返回
      return;
    }

    // 如果当前路径是 download，不加载 typeSeries
    if (window.location.hash.startsWith('#/download')) {
      setState(prev => ({ ...prev, loading: false }));
      return;
    }

    fetchTypeSeries(selectedIndustry)
      .then(data => {
        if (data && data.result && data.result.product_categories) {
          const filteredSeries = data.result.product_categories.filter(
            item => item.product_series && item.product_series.length > 0
          );

          let updatedSeries = filteredSeries;

          if (INDUSTRIES_WITH_HANDBOOK.includes(selectedIndustry)) {
            const handbookCategory = {
              id: `${selectedIndustry}_handbook`,
              name: <FormattedMessage id='handbook' />,
              product_series: [
                {
                  id: `${selectedIndustry}_handbook`,
                  name: <FormattedMessage id='handbook' />,
                  url: 'https://www.inhand.com.cn',
                  entries: ['ProductBrochures'],
                  desc: 'handbook',
                  category_id: 'handbook',
                  spec_prefix: 'handbook',
                  owner: '',
                  bizline: {
                    id: '',
                    no: '',
                    name: { cn: 'handbook' },
                    director: '',
                    state: 'enabled',
                  },
                  director: '',
                  rd_manager: '',
                  validation_test_manager: '',
                  pilot_test_manager: '',
                  validation_test_group: '',
                  change_logs: ['handbook'],
                  changelogMaps: [{ handbook: 'handbook' }],
                  autoTest: false,
                  forChina: true,
                  forGlobal: true,
                },
              ],
            };

            updatedSeries = [...filteredSeries, handbookCategory];
          }

          setState(prev => {
            const newState = {
              ...prev,
              typeSeries: updatedSeries,
              loading: false,
            };

            if (!prev.openType && updatedSeries.length > 0) {
              newState.openType = updatedSeries[0].id;
            }

            if (
              !prev.selectedSeries &&
              updatedSeries.length > 0 &&
              updatedSeries[0].product_series.length > 0
            ) {
              newState.selectedSeries = updatedSeries[0].product_series[0].id;
            }

            return newState;
          });
        }
      })
      .catch(error => {
        console.error('Error fetching type series:', error);
        setState(prev => ({ ...prev, loading: false }));
      });
  }, [industries, selectedIndustry]);

  const generateRoutes = () => {
    let routes = [];
    if (typeSeries.length > 0) {
      typeSeries.forEach(type => {
        type.product_series.forEach(series => {
          routes.push(
            <Route
              key={`${type.id}/${series.id}`}
              path={`${type.id}/${series.id}`}
              element={<Navigate to={`${type.id}/${series.id}`} />}
            />
          );
        });
      });
    }
    return routes;
  };

  useEffect(() => {
    const currentHashname = window.location.hash;
    const pathParts = currentHashname.split('/');
    const currentModel = pathParts[1] || 'EnterpriseNetwork';
    const typeId = pathParts[2];
    const seriesId = pathParts[3];

    if (!typeId && typeSeries.length > 0) {
      const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
      window.location.href = pathname;
    } else if (typeId) {
      const typeExists = typeSeries.some(type => type.id === typeId);
      if (!typeExists && typeSeries.length > 0) {
        const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
        window.location.href = pathname;
      } else {
        setState(prevState => ({
          ...prevState,
          selectedIndustry: currentModel,
          openType: typeId,
          selectedSeries: seriesId,
        }));
      }
    } else if (currentModel === 'EnterpriseNetwork') {
      setState(prevState => ({ ...prevState, selectedIndustry: currentModel }));
    }
  }, [typeSeries]);
  return (
    <IntlProvider
      locale={lang}
      messages={messages[lang]}
    >
      <HashRouter>
        <div className='myFont'>
          <ImgContainer
            keyword={keyword}
            onChangeKeyword={v =>
              setState(prevState => ({ ...prevState, keyword: v }))
            }
            onChangeFlag={v =>
              setState(prevState => ({ ...prevState, flag: v }))
            }
            onChangeSelectedIndustry={v =>
              setState(prevState => ({ ...prevState, selectedIndustry: v }))
            }
          />
        </div>
        <Routes>
          {/* 下载路由优先匹配 */}
          <Route
            path='/download/:docInfo'
            element={<DownloadPage />}
          />

          {/* 主内容路由 */}
          <Route
            path='/'
            element={
              <LayoutCenter
                flag={flag}
                keyword={keyword}
                onChangeFlag={v =>
                  setState(prevState => ({ ...prevState, flag: v }))
                }
                selectedIndustry={selectedIndustry}
                onChangeSelectedIndustry={v =>
                  setState(prevState => ({ ...prevState, selectedIndustry: v }))
                }
                typeSeries={typeSeries}
                onChangeTypeSeries={v =>
                  setState(prevState => ({ ...prevState, typeSeries: v }))
                }
                industries={industries}
                selectedSeries={selectedSeries}
                onchangeSelectedSeries={v =>
                  setState(prevState => ({ ...prevState, selectedSeries: v }))
                }
                openType={openType}
                onchangeOpenType={v =>
                  setState(prevState => ({ ...prevState, openType: v }))
                }
                loading={loading}
                onChangeLoading={v =>
                  setState(prevState => ({ ...prevState, loading: v }))
                }
                handleRouter={generateRoutes}
              />
            }
          >
            {industries.map(industry => (
              <Route
                key={industry.id}
                path={industry.id}
                element={<Navigate to={industry.id} />}
              >
                {typeSeries.length > 0 && generateRoutes()}
              </Route>
            ))}
          </Route>

          {/* 404 路由 */}
          {/* 将 404 路由改为条件渲染 Loading 或 NotFound */}
          <Route
            path='*'
            element={showLoading ? <Loading /> : <NotFound />}
          />
        </Routes>
      </HashRouter>
    </IntlProvider>
  );
}
